import React from "react";
import moment from 'moment';
import {getNLDateString, parseAPIDate} from "../../dateUtils";
import {WeekActionsToolbar} from "./WeekActions";

interface TimeTableNavigationProps {
    date: string
    period: string
    setDate: (date: string) => void
    setPeriod: (period: string) => void
}

export default function TimeTableNavigation(props: TimeTableNavigationProps) {
    function getMonday(d: Date) {
        d = new Date(d);
        var day = d.getDay(),
            diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff));
    }

    function getThisWeek(date: string) {
        const monday = getMonday(parseAPIDate(date))
        const sunday = new Date(monday)
        sunday.setDate(sunday.getDate() + 6)
        return {monday, sunday}
    }

    const dateFormat = (date: string) => {
        if (props.period === "monthly") {
            return moment(parseAPIDate(date)).format("MMMM, YYYY");
        }

        const {monday, sunday} = getThisWeek(date)
        let start_date_week = moment(monday).format('MMM DD');
        let end_date_week = moment(sunday).format('MMM DD, YYYY');
        let week = moment(monday).isoWeek()
        return "wk" + week + " (" + start_date_week + " - " + end_date_week + ")"
    }

    function next() {
        const now = moment(parseAPIDate(props.date));
        const isMonthly = props.period === "monthly"

        if (isMonthly) {
            props.setDate(moment(now).add(1, 'month').format("YYYY-MM-DD"))
        } else {
            props.setDate(now.add(7, 'days').format("YYYY-MM-DD"))
        }
    }

    function prev() {
        const now = moment(parseAPIDate(props.date));
        const isMonthly = props.period === "monthly"

        if (isMonthly) {
            props.setDate(moment(now).subtract(1, 'month').startOf("month").format("YYYY-MM-DD"))
        } else {
            props.setDate(now.subtract(7, 'days').format("YYYY-MM-DD"))
        }
    }

    function curr() {
        props.setDate(getNLDateString())
    }

    return (<div className="toolbar-slider-wrapper">
        <div className="tb-nav-bar">
            <div className="tb-pill-group" id="isMonthly">
                <label className={"tb-pill" + (props.period === "weekly" ? " tb-pill--active" : "")}>
                    <input type="radio" name="options" value="weekly" id="weekly"
                           checked={props.period === "weekly"}
                           onChange={event => props.setPeriod("weekly")}
                    /> Weekly
                </label>
                <label className={"tb-pill" + (props.period === "monthly" ? " tb-pill--active" : "")}>
                    <input type="radio" name="options" id="monthly" value="monthly"
                           checked={props.period === "monthly"}
                           onChange={event => props.setPeriod("monthly")}
                    /> Monthly
                </label>
            </div>

            <div className="tb-nav-divider" aria-hidden="true"/>

            <div className="tb-nav-date">
                <div className="arrow-left" id="get-prev" data-date=""
                     onClick={event => prev()}
                ></div>
                <div className="text-range-date" id="get-current" data-date={props.date}
                     onClick={event => curr()}
                >
                    <span>{dateFormat(props.date)} </span>
                </div>
                <div className="arrow-right" id="get-next" data-date=""
                     onClick={event => next()}
                ></div>
            </div>

            <div className="tb-nav-divider" aria-hidden="true"/>

            <WeekActionsToolbar date={props.date} period={props.period}/>
        </div>
    </div>)
}
